const fichaAssociate = [

  {
    title: 'DADOS PESSOAIS',
    lines: [
      {
        items: [
          {
            id: 'name',
            label: 'Nome',
          },
          {
            id: 'office',
            label: 'Cargo',
          },
          {
            id: 'cpf',
            label: 'CPF',
          },
          {
            id: 'user',
            label: 'Usuário',
          },
        ],
      },

      {
        items: [
          {
            id: 'birth',
            label: 'Nascimento',
          },
          {
            id: 'gender',
            label: 'Sexo',
          },
          {
            id: 'place_of_birth',
            label: 'Naturalidade',
          },
          {
            id: 'nacionality',
            label: 'Nacionalidade',
          },
        ],
      },

      {
        items: [
          {
            id: 'civil_state',
            label: 'Estado Civil',

          },
          {
            id: 'spouse',
            label: 'Conjuge',
          },
          {
            id: 'birth_spouse',
            label: 'Nascimento do conjuge',

          },
        ],
      },

      {
        items: [
          {
            id: 'sons',
            label: 'Filhos',

          },
        ],
      },

      {
        items: [
          {
            id: 'personal_address',
            label: 'Endereço',

          },
          {
            id: 'personal_complement',
            label: 'Complemento',
          },
          {
            id: 'personal_number',
            label: 'Número',
          },
        ],
      },

      {
        items: [
          {
            id: 'personal_district',
            label: 'Bairro',
          },
          {
            id: 'personal_city',
            label: 'Cidade',
          },
          {
            id: 'personal_state',
            label: 'Estado',
          },
          {
            id: 'cep',
            label: 'CEP',
          },
        ],
      },
    ],
  },

  {
    title: 'DADOS FUNCIONAIS',
    lines: [
      {
        items: [
          {
            id: 'allocation',
            label: 'Lotação',
          },
          {
            id: 'acting',
            label: 'Atuação',
          },
        ],
      },

      {
        items: [
          {
            id: 'profissional_address',
            label: 'Endereço',
          },
          {
            id: 'profissional_complement',
            label: 'Complemento',
          },
          {
            id: 'profissional_number',
            label: 'Número',

          },
        ],
      },

      {
        items: [
          {
            id: 'profissional_district',
            label: 'Bairro',
          },
          {
            id: 'profissional_city',
            label: 'Cidade',
          },
          {
            id: 'profissional_state',
            label: 'Estado',
          },
          {
            id: 'cep',
            label: 'CEP',
          },
        ],
      },

      {
        items: [
          {
            id: 'telephone',
            label: 'Telefone',
          },
          {
            id: 'cell_phone_number',
            label: 'Celular',
          },
          {
            id: 'fax',
            label: 'Fax',
          },
        ],
      },

      {
        items: [
          {
            id: 'email',
            label: 'Email',
          },
          {
            id: 'email_REJUFE',
            label: 'Email/Lista',
          },
          {
            id: 'email_ASCOM',
            label: 'Email/Ascom',
          },
        ],
      },
    ],
  },
];
export default fichaAssociate;
